import React from 'react';
import { TextField } from 'ui/components/TextField/TextField';
import { Typography } from '@mui/material';

interface ImagePropertiesProps {
  updateElementProperty: (key: string, value: any) => void;
  handleKeyDown: (event: React.KeyboardEvent) => void;
  imageProps: { src: string };
  setImageProps: React.Dispatch<React.SetStateAction<{ src: string }>>;
}

const ImageProperties: React.FC<ImagePropertiesProps> = ({
  updateElementProperty,
  handleKeyDown,
  imageProps,
  setImageProps,
}) => {
  return (
    <>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        Image Properties
      </Typography>
      <TextField
        className="redesign"
        variant="standard"
        label="Image URL"
        size="small"
        fullWidth
        value={imageProps.src}
        onChange={(e) => {
          const newSrc = e.target.value;
          setImageProps((prev) => ({
            ...prev,
            src: newSrc,
          }));
          updateElementProperty('src', newSrc);
        }}
        onKeyDown={handleKeyDown}
        sx={{ mb: 2 }}
        placeholder="Enter image URL"
      />
    </>
  );
};

export default ImageProperties;
